import { PermissionArrayType } from '../../../../types/other';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../../features/utils/utils.action';
import { AddressType } from '../../../../components/Address/Address.types';
import { ShippingPackageFormType } from '../Orders/Order';
import { UserType } from '../../../../types/user/user.type';

export const fulfillmentOrderPermissions: PermissionArrayType = {
  CREATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  UPDATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
  ],
};

export type CreateFulfillmentOrderFormType = {
  fromWarehouse: null | { id: number; name: string };
  toWarehouse: null | { id: number; name: string };
  ccNotifyUsers: Array<{ id: number; name: string; email: string; firstname: string; lastname: string }>;
};

export type UpdateFulfillmentOrderFormType = {
  status: string;
  fromWarehouse: { id: number; name: string } | null;
  toWarehouse: { id: number; name: string } | null;
  ccNotifyUsers: Array<Pick<UserType, 'id' | 'firstname' | 'lastname' | 'email'>>;
  address: AddressType;
  shippingPackages: Array<ShippingPackageFormType>;
  invoiceNumber?: string;
  paymentNumber?: string;
  invoiceFile?: File | null;
};
